<template>
  <SignupFieldComponent
    :field
    :value="model"
    :rules
    v-slot="{ id, invalid, touch }"
  >
    <div class="form-check">
      <input
        :id
        type="checkbox"
        v-model="model"
        class="form-check-input"
        :class="{ 'is-invalid': invalid }"
        @blur="touch"
      />
    </div>
  </SignupFieldComponent>
</template>

<script setup lang="ts">
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { GeneratorReviewKey } from "./fieldKeys";
import SignupFieldComponent from "./SignupFieldComponent.vue";

withDefaults(
  defineProps<{
    field: GeneratorReviewKey;
    rules?: ValidationRuleCollection;
  }>(),
  { rules: () => ({}) }
);

const model = defineModel<boolean | null>({ default: null });
</script>
